import { ACTION_TYPES } from '../constants';

export default (url, data) => ({
  type: ACTION_TYPES.FETCH_VOD_PATH_SUCCESS,
  payload: {
    url,
    data
  }
});
